import { ABaseModel } from '@pperform/pp-data-mappers';

export class ShippingAttachmentRespDTO extends ABaseModel {
  type = '';

  base64Content = '';

  fileName = '';

  mimeType = '';
}
